// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__pD1mn","section":"styles_section__grUyC","fixed":"styles_fixed__0M0DB","content":"styles_content__lw_aq"};